<div class="fixed inset-0 z-[99999] flex items-center justify-center bg-black/60 p-4" role="presentation">
  <div class="relative flex max-h-[calc(100vh-32px)] w-full max-w-[560px] flex-col overflow-hidden rounded-xl bg-white text-[#344054] shadow-xl"
    role="dialog" aria-modal="true" aria-labelledby="report-job-modal-title">
    <header class="relative overflow-hidden px-6 pb-5 pt-6">
      <div aria-hidden="true" class="pointer-events-none absolute -left-[120px] -top-[120px] h-[336px] w-[336px] [mask-image:url('/images/report-job-modal-pattern-mask.svg')] [mask-size:336px_336px]">
        <img src="images/report-job-modal-pattern.svg" alt="" class="h-full w-full" />
      </div>

      <div class="relative h-12 w-12">
        <img src="images/report-job-modal-featured-icon.svg" alt="" aria-hidden="true" class="absolute inset-0 h-full w-full" />
        <span class="absolute left-1/2 top-1/2 flex h-8 w-8 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-[#DC6803]">
          <img src="images/report-job-modal-help-circle.svg" alt="" aria-hidden="true" class="h-5 w-5" />
        </span>
      </div>
      <button type="button" aria-label="Close report dialog" (click)="closed.emit()"
        class="absolute right-4 top-4 flex h-9 w-9 cursor-pointer items-center justify-center rounded-lg p-2 hover:bg-[#F2F4F7]">
        <img src="images/report-job-modal-close.svg" alt="" aria-hidden="true" class="h-5 w-5" />
      </button>

      <div class="relative mt-4 flex flex-col gap-1">
        <h2 id="report-job-modal-title" class="m-0 text-lg font-semibold leading-7 text-[#101828]">Report Job</h2>
        <p class="m-0 text-sm leading-5 text-[#475467]">NB: Your submitted information will be passed to Bdjobs.com for verification.</p>
      </div>
    </header>

    <form [formGroup]="reportForm()" (ngSubmit)="submitReport()" class="flex min-h-0 flex-col overflow-y-auto px-6">
      @if (!formValue) {
      <div class="flex flex-col gap-1.5">
        <label for="report-email" class="text-sm font-medium leading-5 text-[#344054]">
          Your email address / Mobile No <span class="text-[#D92D20]">*</span>
        </label>
        <input id="report-email" type="text" formControlName="email" placeholder="Enter your email"
          autocomplete="off"
          class="h-10 w-full rounded-lg border border-[#D0D5DD] bg-white px-3 text-sm leading-5 text-[#344054] shadow-[0_1px_1px_rgba(16,24,40,0.05)] outline-none placeholder:text-[#667085] focus:border-[#0E73A9] focus:ring-1 focus:ring-[#0E73A9]" />
        @if (reportForm().get('email')?.invalid && reportForm().get('email')?.touched) {
        <p class="m-0 text-sm font-medium text-[#D92D20]">Please provide your email.</p>
        }
      </div>
      }

      <div class="mt-3 flex flex-col gap-1.5">
        <app-custom-selectbox
          [options]="reportSelectItems()"
          [control]="reportTypeControl()"
          placeholder="Select report type"
          label="Report type"
          [isRequired]="true"
          name="report-type"
          customClasses="report-type-select">
        </app-custom-selectbox>
        @if (reportForm().get('ReportType')?.invalid && reportForm().get('ReportType')?.touched) {
        <p class="m-0 text-sm font-medium text-[#D92D20]">Please select a report type.</p>
        }
      </div>

      <div class="mt-3 flex min-h-[150px] flex-col gap-1.5">
        <label for="report-comments" class="text-sm font-medium leading-5 text-[#344054]">Description</label>
        <textarea id="report-comments" rows="4" formControlName="Comments" maxlength="500" placeholder="Enter a description..."
          class="min-h-[100px] flex-1 resize-y rounded-lg border border-[#D0D5DD] px-3.5 py-3 text-base leading-6 text-[#344054] shadow-[0_1px_2px_rgba(16,24,40,0.05)] outline-none placeholder:text-[#667085] focus:border-[#0E73A9] focus:ring-1 focus:ring-[#0E73A9]"></textarea>
        <p class="m-0 text-sm leading-5 text-[#475467]">Within 500 characters</p>
      </div>

      <div class="flex gap-3 px-0 pb-6 pt-6">
        <button type="submit" [disabled]="reportForm().invalid"
          class="h-10 flex-1 cursor-pointer rounded-lg border border-[#0E73A9] bg-[#0E73A9] px-4 text-sm font-semibold leading-5 text-white shadow-[0_1px_2px_rgba(16,24,40,0.05),inset_0_-2px_0_rgba(16,24,40,0.05)] hover:bg-[#0E6596] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#0E73A9] disabled:cursor-not-allowed disabled:opacity-50">
          Submit
        </button>
        <button type="button" (click)="closed.emit()"
          class="h-10 flex-1 cursor-pointer rounded-lg border border-[#D0D5DD] bg-white px-4 text-sm font-semibold leading-5 text-[#344054] shadow-[0_1px_2px_rgba(16,24,40,0.05)] hover:bg-[#F9FAFB] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#98A2B3]">
          Cancel
        </button>
      </div>
    </form>
  </div>
</div>